import Icon from '../components/Icon.vue'

Icon.register({"bullseye":{"width":512,"height":512,"paths":[{"d":"M256 72C357.7 72 440 154.3 440 256 440 357.7 357.7 440 256 440 154.3 440 72 357.7 72 256 72 154.3 154.3 72 256 72M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 192C291.3 192 320 220.7 320 256S291.3 320 256 320 192 291.3 192 256 220.7 192 256 192M256 128C185.3 128 128 185.3 128 256S185.3 384 256 384 384 326.7 384 256 326.7 128 256 128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/bullseye.js
// module id = null
// module chunks = 